<template>
    <div class="loading-box">
        <div class="van-loading van-loading--circular van-loading--vertical"
             style="top: 50%; position: absolute; left: 50%; margin-top: -12px;margin-left: -12px;">
            <span class="van-loading__spinner van-loading__spinner--circular"
                  style="color: rgb(25, 137, 250); width: 24px; height: 24px;">
                <svg viewBox="25 25 50 50" class="van-loading__circular">
                    <circle cx="50" cy="50" r="20" fill="none"></circle>
                </svg>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "loadingAa"
    }
</script>

<style scoped>
    .loading-box {
        height: 100vh;
        width: 100vw;
        z-index: 2002 !important;
        background-color: rgba(0, 0, 0, .7) !important;
        position: absolute;
        left: 0;
        top:0;
        bottom: 0;
        right:0
    }
</style>